<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <v-card>
      <v-toolbar flat color="secondary">
        <v-toolbar-title class="white--text">
          {{ title || "Warning" }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text
        class="black--text pt-5 text-center font-weight-bold"
        style="font-size: 20px"
      >
        <span>
          {{ message1 ? message1 : "Are you sure ?" }}
        </span>
      </v-card-text>
      <v-card-text
        class="black--text text-center font-weight-medium"
        style="font-size: 18px"
      >
        <span v-if="message2">
          {{ message2 }}
        </span>
        <span v-else>
          Do you really want to delete this record ?
          <p class="mb-0">This process cannot be undone.</p>
        </span>
      </v-card-text>
      <div class="mx-4">
        <v-divider></v-divider>
      </div>
      <v-card-actions class="px-4 py-5 justify-center">
        <v-btn
          @click="closeWithAction(false)"
          outlined
          class="mr-2 px-5"
          right
          height="44"
          depressed
          color="primary"
          style="font-weight: 600"
        >
          {{ cancelBtnText ? cancelBtnText : $t("cancel") }}
        </v-btn>
        <v-btn
          depressed
          height="44"
          color="error"
          class="px-5"
          style="font-weight: 600"
          @click="closeWithAction(true)"
        >
          {{ confirmBtnText ? confirmBtnText : $t("delete") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    message1: {
      type: String,
      required: false,
    },
    message2: {
      type: String,
      required: false,
    },
    confirmBtnText: {
      type: String,
      required: false,
    },
    cancelBtnText: {
      type: String,
      required: false,
    },
    confirmData: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    closeWithAction(action) {
      this.$emit("confirm:action", action, this.confirmData);
    },
  },
};
</script>
